module.exports = __webpack_public_path__ + "static/media/imgGalleryM6.fede9f2c.svg";